import React from 'react'
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'
import { useTranslation } from 'react-i18next'
import { CustomIcon } from './mixins'

export const FormTitle = () => {
  // Hooks
  const { t } = useTranslation()
  const { isMobile } = useWindowSize()

  return (
    <>
      {!isMobile && <CustomIcon name="icon-light-megaphone" size="26" color="rgba(0, 0, 24, 0.84)" />}
      {t('alertas.form.title')}
    </>
  )
}
